export const appendSasToken = (url, token) => {
  if (!url || !token) return '';

  const normalizedToken = token.replace(/^\?/, '');
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${normalizedToken}`;
};
